var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.748,
    height: 23.748,
    viewBox: "0 0 23.748 23.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-add-circle-outline",
    "data-name": "Icon ionic-ios-add-circle-outline",
    transform: "translate(-2.875 -2.875)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M21.284,15.461H17.21V11.387a.875.875,0,1,0-1.75,0v4.074H11.387a.838.838,0,0,0-.875.875.847.847,0,0,0,.875.875h4.074v4.074a.847.847,0,0,0,.875.875.871.871,0,0,0,.875-.875V17.21h4.074a.875.875,0,1,0,0-1.75Z",
    transform: "translate(-1.586 -1.586)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M14.749,4.906A9.839,9.839,0,1,1,7.788,7.788a9.778,9.778,0,0,1,6.961-2.882m0-1.531A11.374,11.374,0,1,0,26.123,14.749,11.372,11.372,0,0,0,14.749,3.375Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add-icon.334f916389f806da60f567e6ae9ac02b.svg";
export { ForwardRef as ReactComponent };